import React, { useEffect } from 'react'
import { useTranslation } from 'react-multi-lang'
import { useDispatch, useSelector } from 'react-redux'
import DetailsModal from '../../../components/DetailsModal/DetailsModal'

import { showServiceSlice, showServiceState } from './ShowModalSlice'
import { havePermission } from '../../../services/hoc/permissions'
import { Confirm } from '../../../components/Alerts/Alerts'

import { addServiceSlice } from '../AddModal/AddModalSlice'
import { servicesSlice } from '../ServicesSlice'

import { useAPI } from '../../../services/hoc/useAPI'


export type attribute_types = "String" | "Number" | "Pre-defined" | "Date"

export interface manageAttributesState {
    attributes: attribute[],
    isOpen: boolean
}


export interface attribute {
    id?: number;
    name?: string,
    type?: attribute_types,
    min?: number,
    max?: number,
    hint?: string,
    items?: string[]
}

const ShowService = ({close}:{close:Function}) => {

    // Translation
    const t = useTranslation()

    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { show_service: showServiceState }) => state.show_service)

const ENDPOINTS = useAPI()

    const toggle = () => {
        close()
        dispatch(showServiceSlice.actions.setIsOpen({ id: state.id, isOpen: false }))}

    const fetchData = () => {

        ENDPOINTS.components("service").show({ id: state.id })
            .then((response: any) => {
                dispatch(showServiceSlice.actions.setIsLoaded(true))
                dispatch(showServiceSlice.actions.setData({
                    name: response.data.data.name,
                    description: response.data.data.description,
                    serial_number: response.data.data.serial_no,
                    attributes: response.data.data.attributes_list
                }))
            })

    }


    const fixPredefinedFormat = (attributes: attribute[]): attribute[] => {
        attributes = attributes.map(attribute => {
            if (attribute.type === "Pre-defined") {
                attribute.items = attribute.items?.map((item: any) => item.name)
            }
            return attribute
        })
        return attributes
    }


    // Delete
    const remove = (id: number) => {
        let ids = [id]
        dispatch(servicesSlice.actions.setIsLoading(true))
        ENDPOINTS.components("service").delete({ ids })
            .then(() => {
                toggle()
                dispatch(servicesSlice.actions.setIsLoading(false))
                dispatch(servicesSlice.actions.deleteServices(ids))
            })
    }

    useEffect(() => {
        dispatch(showServiceSlice.actions.setIsLoaded(false))
        if (state.id !== 0)
            fetchData()
    }, [state.id])

    return (
        <DetailsModal data={(({ attributes, product_attributes, ...data }) => data)(state.data)} isOpen={state.isOpen} isLoading={!state.isLoaded} toggle={toggle} title={t("service_details")} product_attributes={state.data.product_attributes} attributes={state.data.attributes} actions={
            <div className="show-on-hover">
                {havePermission("Edit Component") ?
                    <i className="icon-edit" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                        e.stopPropagation()
                        toggle()
                        dispatch(addServiceSlice.actions.setIsOpen(true))
                        dispatch(addServiceSlice.actions.setIsLoading(true))
                        dispatch(addServiceSlice.actions.setEditId(state.id))
                        ENDPOINTS.components("service").show({ id: state.id })
                            .then((response: any) => {
                                dispatch(addServiceSlice.actions.set({
                                    attributes: fixPredefinedFormat(response.data.data.attributes_list),
                                    description: response.data.data.description,
                                    name: response.data.data.name,
                                    code: response.data.data.serial_no,
                                }))
                                dispatch(addServiceSlice.actions.setIsLoading(false))
                            })
                    }} /> : ""}
                {havePermission("Delete Component") ?
                    <i className="icon-delete" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                        e.stopPropagation()
                        Confirm({
                            message: t("delete_confirmation"),
                            onConfirm: () => remove(state.id)
                        })
                    }} /> : ""}
            </div>
        } />
    )

}

export default ShowService